import axios from "axios";
import API from "../_helpers/endpointService";

export const getIR_ListView = (data, id) => {
    let ids = "";
    if (data.Incidenttype.length >= 0) {
        for (var i in data.Incidenttype) {
            ids += "&Incidenttype=" + data.Incidenttype[i];
        }
    }
    let apiUrl = API.IR_LISTVIEW + "?projectId=" + id + "&DateFrom=" + data.DateFrom + "&DateTo=" + data.DateTo + '&Investigationtype=' + data.Investigationtype + '' + ids + '' + '&PageNumber=' + data.PageNumber + '&PageSize=' + data.PageSize;
    return (dispatch) => {
        dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    dispatch({ type: "IRLIST_DOCS", data: response.data });
                } else {
                }
            })
            .catch((error) => {
                dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };
};
export const deletemulitiirdocs = (data, id, modify) => {
    let ids = "";
    if (data && data.length > 0) {
        data.map((val, index) => {
            if (index == 0) {
                ids += "ids=" + val.data;
            }
            else {
                ids += "&ids=" + val.data;
            }
        })
    }
    let apiUrl = API.IR_LISTVIEW + '/ids?' + ids + '&modify=' + modify
    return (dispatch) => {
        dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "DELETE",
            url: apiUrl,
        })
            .then((response) => {
                dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                } else {
                }
            })
            .catch((error) => {
                dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                }
            });
    };

};
export const filedeleteDoc = (id, name) => {
    let apiUrl = API.IR_LISTVIEW + '/Document/id?id=' + id + '&filename=' + name;
    return (dispatch) => {
        axios({
            method: "DELETE",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                } else {
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                }
            });
    };
};
export const filedeleteirPhoto = (id, name) => {
    let apiUrl = API.IR_LISTVIEW + '/Photo/id?id=' + id + '&filename=' + name;
    return (dispatch) => {
        axios({
            method: "DELETE",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                } else {
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };
};
export const gethistorylogIR = (id) => {
    let apiUrl = API.HISTORY_LOG + id + '?name=InvestigationReport'
    return (dispatch) => {
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    dispatch({ type: "HISTORY_LOG", data: response.data });
                } else {
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };
};
export const downloadmultipleirdocs = (data) => {
    let keys = "";
    if (data && data.length > 0) {
        data.map((val, index) => {
            if (index == 0) {
                keys += "keys=" + val.ObjectKey;
            }
            else {
                keys += "&keys=" + val.ObjectKey;
            }
        })
    }
    let apiUrl = API.IR_LISTVIEW + '/keys?' + keys;
    return (dispatch) => {
        dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "get",
            url: apiUrl,
            responseType: "blob",
            // data: data,
            // headers : {
            //   'content-type': 'application/json'
            // }
        })
            .then((response) => {
                dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    let blob = new Blob([response.data]);
                    let url = URL.createObjectURL(blob);
                    let a = document.createElement('a');
                    a.href = url;
                    a.download = "Investigation Report.zip"
                    a.click();
                } else {
                }
            })
            .catch((error) => {
                dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                }
            });
    };
};
export const deleteIR = (id, modify) => {
    let apiUrl = API.IR_LISTVIEW + '/' + id + '?modify=' + modify;
    return (dispatch) => {
        dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "delete",
            url: apiUrl,
        })
            .then((response) => {
                dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                } else {
                }
            })
            .catch((error) => {
                dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                }
            });
    };
};